import {removeMaterialFunction} from "@project/sdk/engineering";
import {mutationOptions} from "@tanstack/react-query";

import {materialKeys, materialMutationKeys} from "../../../../../material-keys";

export function removeMaterialFunctionMutationOptions(id: string) {
  return mutationOptions({
    mutationKey: materialMutationKeys.removeMaterialFunction,
    mutationFn: (functionId: string) => removeMaterialFunction(id, functionId),
    onSuccess: async (_result, _variables, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: materialKeys.detail(id)}),
        client.invalidateQueries({queryKey: materialKeys.lists()}),
      ]);
    },
  });
}
